export const ASK_DAISY_PRICING_QUERY_PARAM_KEY = 'ask-daisy-pricing'
